import { enUS } from 'date-fns/locale'

export { enUS }
export default enUS
